import { OTHER_ASSET_TYPE } from '~/constants/template';

export type AssetTypeOption = {
  value: string;
  label: string;
};

/**
 * Builds asset type options from global and location-specific asset types.
 * For asset-driven templates, automatically includes the "Other" option to allow
 * rules that match assets not covered by other rules.
 *
 * @param globalAssetTypes - Global asset types from the system
 * @param selectedLocationAssetTypes - Asset types filtered by selected locations/scopes
 * @param isAssetDrivenTemplate - Whether this is for an asset-driven template context
 * @returns Array of Option objects sorted alphabetically
 */
export function buildAssetTypeOptions(
  globalAssetTypes: string[] | null | undefined,
  selectedLocationAssetTypes: string[] | null | undefined,
  isAssetDrivenTemplate = false
): AssetTypeOption[] {
  const global = (globalAssetTypes || []).filter(Boolean) as string[];
  const refine = (selectedLocationAssetTypes || []).filter(Boolean) as string[];
  const baseList = refine.length > 0 ? refine : global;
  const options = baseList
    .slice()
    .sort()
    .map((name) => ({ value: name, label: name }));

  // Add "Other" option for asset-driven templates
  // This allows users to create a task rule that matches assets not covered by other rules
  if (isAssetDrivenTemplate) {
    // Check if "Other" already exists in the list
    const hasOther = options.some((opt) => opt.value === OTHER_ASSET_TYPE);
    if (!hasOther) {
      options.push({
        value: OTHER_ASSET_TYPE,
        label: OTHER_ASSET_TYPE,
      });
    }
  }

  return options;
}
